<template>
     <div class="produits">
      
      <h1 class="produits-title">Consommables</h1>
    
      <!-- Breadcrumb -->
      <div class="breadcrumb">
        <a href="/">Accueil</a> > <a href="/produits">Produits</a> > <a href="/ConsomablesComp">Consommables</a>
      </div>
  <div class="produits-container">
      <div class="container">
        <div class="produits-categories">
          <div class="category-card">
           <img src="@/assets/MARQUES/trustlab.png" alt="truslab">
            <RouterLink to="/trust">Tube de prélèvement/Papier PH/Pipette/Lames/Lamelle</RouterLink>
          </div>
          <div class="category-card">
            <h1>ALTO</h1><br/>

            <RouterLink to="/alto">Boite de Pétri/Flacon </RouterLink>
          </div>
               <div class="category-card">
            <img src="@/assets/MARQUES/flmedical.png" alt="flmedical">
            <RouterLink to="/flmed">Tube de prélèvement</RouterLink>
          </div>
             
         </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReactifsI',
  data() {
    return {
     
    };
  }
};
</script>

<style scoped>
/* ======== MODE CLAIR ======== */
.produits-title {
  background-image: url('C:/Users/PC MAROC/supracare_Shop/src/assets/consom.jpg');
  background-size: cover;
  background-position: center;
  color: rgb(29, 22, 77);
  padding: 200px 300px;
  font-size: 40px;
  margin: 0 auto;
  text-align: center;
  border-radius: 2px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  max-width: 1000px;
}

.produits-container {
  padding: 0;
  background-color: #f9f9f9;
  text-align: justify;
  z-index: 1;
  overflow: hidden;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  margin-bottom: 500px;
  transition: background-color 0.3s ease, color 0.3s ease;
}

.produits {
  max-width: 1200px;
  margin: 0 auto;
  padding: 5px;
  font-size: 16px;
  color: #333;
  background: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border-radius: 10px;
}

.breadcrumb {
  font-size: 10px;
  color: #888;
  margin-top: 10px;
}

.breadcrumb a {
  color: #1c1c1d;
  text-decoration: none;
  transition: color 0.3s ease;
}

.breadcrumb a:hover {
  color: #0056b3;
}

.container {
  max-width: 1000px;
  margin: auto;
  padding: 20px;
}

.produits-categories {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 103px;
  justify-content: center;
}

.category-card {
  background: white;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  text-align: center;
  padding: 20px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  width: 200px;
}

.category-card:hover {
  transform: scale(1.05);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3);
}

.category-card img {
  width: 100px;
  height: 100px;
  object-fit: contain;
  margin-bottom: 10px;
}

.category-card a {
  display: block;
  color: #05305b;
  font-size: 14px;
  font-weight: bold;
  text-decoration: none;
  padding: 5px;
  border-radius: 5px;
  transition: color 0.3s ease, transform 0.3s ease;
  text-align: center;
  word-wrap: break-word;
  overflow-wrap: break-word;
  max-width: 100%;
}

.category-card a:hover {
  color: #e0240b;
}

/* ======== RESPONSIVE ======== */
@media only screen and (max-width: 1040px) {
  .produits-title {
    padding: 100px 50px;
    font-size: 24px;
    max-width: 90%;
    margin: 0 auto;
  }

  .produits {
    padding: 10px;
    font-size: 14px;
  }

  h2 {
    font-size: 20px;
    margin-top: 30px;
  }
}

@media only screen and (max-width: 450px) {
  .produits-title {
    padding: 50px 0;
    font-size: 18px;
    max-width: 100%;
    margin-top: 10px;
  }

  .produits {
    padding: 5px;
    font-size: 12px;
  }

  h2 {
    font-size: 18px;
    margin-top: 20px;
  }

  .produits, .produits-title {
    box-shadow: none;
  }
}

/* ======== 🌙 MODE SOMBRE ======== */
@media (prefers-color-scheme: dark) {
  body, .produits-container {
    background-color: #0b0f14;
    color: #e6edf1;
  }

  .produits {
    background-color: #10151c;
    color: #e6edf1;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.6);
  }

  .produits-title {
    background-image: linear-gradient(
      rgba(5, 5, 10, 0.7),
      rgba(5, 5, 10, 0.7)
    ), url('C:/Users/PC MAROC/supracare_Shop/src/assets/consom.jpg');
    background-size: cover;
    background-position: center;
    color: #aef7f0;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.8);
  }

  .breadcrumb {
    color: #aaa;
  }

  .breadcrumb a {
    color: #73d8cf;
  }

  .breadcrumb a:hover {
    color: #00bfa5;
  }

  .category-card {
    background-color: #142231;
    color: #e6edf1;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.6);
  }

  .category-card:hover {
    background-color: #00998B;
    transform: scale(1.05);
  }

  .category-card a {
    color: #aef7f0;
  }

  .category-card a:hover {
    color: #00bfa5;
  }
}
</style>

